import styled from 'styled-components'
import { palette } from '~components/homepage/styled/constants'

export const ArticleDate = styled.p`
  font-size: 10px;
  font-family: 'Averta-Regular', sans-serif;
  color: ${palette.darkBiege};
  margin: 0px;
  padding-top: 15px;
`

export const ArticleTitle = styled.p`
  font-size: 15px;
  font-family: 'Averta-SemiBold', sans-serif;
  color: ${palette.darkBlue};
  margin: 0px;
`

export const ArticleDescription = styled.p`
  font-size: 13px;
  font-family: 'Averta-Regular', sans-serif;
  color: ${palette.darkBiege};
  margin-bottom: 0px;
  line-height: 22px;
`

export const Divider = styled.div`
  width: calc(100% - 40px);
  margin: 0 auto;
  background-color: ${palette.inputBorder};
  height: 1px;
`
